import { Cart } from '../adapters/CartApiAdapter';
import { EntryLine } from '../../models/Entry';

// Pasos del flujo de recepción
export type ReceiveStep = 'cart' | 'products';

// Estado del flujo de recepción
export interface ReceiveFlowState {
  currentStep: ReceiveStep;
  validatedCart: Cart | null;
  isProcessing: boolean;
  error: string | null;
}

// Producto escaneado con cantidad
export interface ScannedProduct {
  productId: number;
  productCode: string;
  productName: string;
  entryLineId: number;
  expectedQty: number;
  scannedQty: number;
}

// Producto pendiente de procesar (escaneado pero sin cantidad establecida)
export interface PendingProduct {
  productId: number;
  productCode: string;
  productName: string;
  entryLineId: number;
  expectedQty: number;
  maxAvailableQty: number; // Cantidad máxima disponible para escanear (expectedQty - ya escaneado)
}

// Datos para rechazo
export interface RejectionData {
  productId: number;
  qty: number;
  rejectionType: string;
  rejectionText?: string;
  attachments: File[];
}

// Producto de entrada con información adicional
export interface EntryProductInfo extends EntryLine {
  product?: {
    id: number;
    name: string;
    code: string;
    image?: string;
    image_hash?: string;
    img?: string;
  };
  scannedQty?: number; // Deprecated: usar qty_accept + qty_rejects
  acceptedQty?: number; // Deprecated: usar qty_accept
  rejectedQty?: number; // Deprecated: usar qty_rejects
}

// Códigos especiales de requisitos que marcan incumplimiento automático
export const NON_COMPLIANCE_REQUIREMENT_CODES = [
  'MERCANCIA_MEZCLADA',
  'MERCANCIA_NO_ETIQUETADA',
  'BARCODE_NO_LEGIBLE',
  'MERCANCIA_SIN_REFERENCIA',
  'PALET_ALTURA_SUPERIOR_180',
  'PALET_FILM_NEGRO',
  'ETIQUETADO_INCORRECTO',
] as const;

export type NonComplianceRequirementCode = (typeof NON_COMPLIANCE_REQUIREMENT_CODES)[number];

export const NON_COMPLIANCE_LABELS: Record<NonComplianceRequirementCode, string> = {
  MERCANCIA_MEZCLADA: 'Mercancía Mezclada',
  MERCANCIA_NO_ETIQUETADA: 'Mercancía No Etiquetada',
  BARCODE_NO_LEGIBLE: 'Código de Barras No Legible',
  MERCANCIA_SIN_REFERENCIA: 'Mercancía sin Referencia',
  PALET_ALTURA_SUPERIOR_180: 'Palé supera 180cm de altura',
  PALET_FILM_NEGRO: 'Palé con Film Negro',
  ETIQUETADO_INCORRECTO: 'Etiquetado del Producto Incorrecto',
};

// Tipos de rechazo comunes
export enum RejectionType {
  DAMAGED = 'DAMAGED',
  EXPIRED = 'EXPIRED',
  WRONG_PRODUCT = 'WRONG_PRODUCT',
  INCOMPLETE = 'INCOMPLETE',
  OTHER = 'OTHER',
}

export const REJECTION_TYPE_LABELS: Record<RejectionType, string> = {
  [RejectionType.DAMAGED]: 'Dañado',
  [RejectionType.EXPIRED]: 'Caducado',
  [RejectionType.WRONG_PRODUCT]: 'Producto incorrecto',
  [RejectionType.INCOMPLETE]: 'Incompleto',
  [RejectionType.OTHER]: 'Otro',
};
